<template>
  <v-container class="my-5">
    <h2 class="subheading grey--text">Torneos de Golf</h2>

    <v-card class="elevation-0 mt-4">
      <v-card-title>
        Lista de Torneos
      </v-card-title>
      <v-card-text>
        <v-data-table
            :headers="headers"
            :items="tournaments"
            class="elevation-1"
            no-data-text="No hay torneos registrados"
        >
          <template v-slot:item.status="{ item }">
            <v-chip
                :color="getStatusColor(item.status)"
                text-color="white"
                small
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                color="primary"
                @click="viewTournamentMembers(item)"
                style="cursor: pointer;"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ClubHouseTournaments',
  data () {
    return {
      headers: [
        { text: 'Nombre', value: 'name', sortable: true },
        { text: 'Fecha', value: 'date', sortable: true },
        { text: 'Hora', value: 'start_time', sortable: false },
        { text: 'Categoría', value: 'category', sortable: false },
        { text: 'Estado', value: 'status', sortable: true },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      tournaments: [
        {
          id: 1,
          name: 'Torneo infantil - juvenil primera etapa',
          date: '2026-09-11',
          start_time: '9:00 AM',
          category: 'Infantil - Juvenil',
          status: 'Próximo',
          description: 'Primer torneo infantil y juvenil del año'
        }
      ]
    }
  },
  methods: {
    getStatusColor (status) {
      const colors = {
        'Próximo': 'blue',
        'En Curso': 'orange',
        'Completado': 'green'
      }
      return colors[status] || 'gray'
    },
    viewTournamentMembers (tournament) {
      this.$router.push({
        name: 'ClubHouseTournamentMembers',
        params: {
          tournamentId: tournament.id,
          tournamentName: tournament.name
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
